import { render, staticRenderFns } from "./MovieSite.vue?vue&type=template&id=087d595b&scoped=true"
import script from "./MovieSite.vue?vue&type=script&lang=js"
export * from "./MovieSite.vue?vue&type=script&lang=js"
import style0 from "./MovieSite.vue?vue&type=style&index=0&id=087d595b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087d595b",
  null
  
)

export default component.exports